import { render, staticRenderFns } from "./EditProfilePhotoRequest.vue?vue&type=template&id=5b752de6&scoped=true"
import script from "./EditProfilePhotoRequest.vue?vue&type=script&lang=js"
export * from "./EditProfilePhotoRequest.vue?vue&type=script&lang=js"
import style0 from "./EditProfilePhotoRequest.vue?vue&type=style&index=0&id=5b752de6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b752de6",
  null
  
)

export default component.exports